module.exports = __webpack_public_path__ + "static/black-argus-b76d8059e89066b9cbc6456b05a6634c.png";